import configData from "../../config.json";

const initialState = {
  backendUrl: configData.REACT_APP_BACKEND_URL || "http://localhost:4000"
};

const configReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_BACKEND_URL":
      return {
        ...state,
        backendUrl: action.payload
      };
    default:
      return state;
  }
};

export default configReducer;
